import React from "react"
import virgolette from '../../pageComponents/images/virgolette-mobile.svg'

const Page8Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-5 barra-arancio'></div>
        <div className='mt-5 font-20 line-height-26'>
          Un trend, questo, presente da tempo: le vetture elettriche acquistate
          in Italia nel 2018 sono state oltre 2500, contro le 550 dell’anno precedente,
          registrando una crescita del 366 per cento; non è lo stesso per quelle a benzina,
          che in termini di vendite hanno perso nel giro di un anno 15 punti percentuali.
        </div>
        <div className='mt-2 font-20 line-height-26'>
          Più in generale, i vantaggi dei veicoli elettrici maggiormente percepiti dai
          fleet manager sono di natura economica (risparmio di carburante, libero accesso alle ZTL,
          altre agevolazioni nella circolazione o sosta) e reputazionale (responsabilità
          d'impresa alla riduzione delle emissioni inquinanti e climalteranti).
        </div>
        <div className='mt-2 font-20 line-height-26'>
           Rispetto al 2018, si registra inoltre una crescita di 10 punti percentuali
           – dal 46 per cento al 56 per cento – delle imprese che hanno installato
           soluzioni di ricarica presso la propria sede, e di 20 punti percentuali –
           dal 63 per cento all’84 per cento – di quelle che hanno stipulato accordi
           con le utilities dell’energia.
        </div>
        <div className='mt-2 font-20 line-height-26'>
          L’esperienza di alcuni Paesi virtuosi – come la Norvegia –
          sulla conversione all’elettrico ha dimostrato indubbiamente che quando
          la politica incentiva l’acquisto di veicoli a impatto zero,
          il consumatore risponde positivamente.
        </div>
        <div className='mt-5 col-spread-gutter'>
          <div className='text-center pb-2 pt-2 col-inset-gutter' style={{ backgroundColor: '#005BBB', borderRadius: 20 }}>
            <img src={virgolette} alt='Virgolette'  />
            <div className='pt-2 text-left font-family-acumin font-20 line-height-26 font-weight-500 text-white'>
              «Abbiamo 11 sedi, di cui sette concentrate nel Nord Italia e una
              flotta aziendale di circa 130 auto. Fino al 2015 abbiamo avuto una
              flotta tradizionale a diesel, poi abbiamo attuato un cambio di
              direzione, grazie alla lungimiranza. L’azienda era cosciente del
              fatto che i pionieri devono sostenere il prezzo dell’innovazione:
              a volte bisogna indicare la strada agli altri, a costo di
              decisioni impopolari».
            </div>
            <div className='mt-4 text-white'>
              <div style={{ height: 2, backgroundColor: '#FF6B29', width: 40}}></div>
              <div className='mt-1 font-16 text-left'>
                Mauro Rondella
              </div>
              <div className='font-14 text-left'>
                Alfa Laval — Site Service Manager
              </div>
              <div className='mt-3 font-14 text-right'>
                Fonte: Il Sole 24 Ore
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page8Mobile
